import React, { Component } from 'react';
import propTypes from 'prop-types';
import { NavLink } from 'react-router-dom';
import { connect } from 'react-redux';
import { withNavigation } from 'src/ui/hoc';

import { Card, CardContent, MuiTitle } from 'src/ui/mui-ui-kit';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { Form } from 'react-final-form';
import { toast } from 'react-toastify';
import dayjs from 'dayjs-ext';

import {
  setBreadcrumbs,
  reduceServerErrors,
  UiToastAdapter,
  InnerLoader,
} from 'src/ui';
import { getUser } from 'src/user';

import {
  fetchTasks,
  addAccountTask,
  updateAccountTask,
  getAccount,
} from 'src/account';
import { ScheduledTasksEditForm } from '../components';
/* eslint-disable no-unused-expressions */
class ScheduledTasksEditPage extends Component {
  state = {
    loading: true,
    title: '',
    initialValues: {},
    confirmChangesModal: false,
  };

  async componentDidMount() {
    const { match, setBreadcrumbs, fetchTasks } = this.props;
    const { id } = match.params;

    // If we have an id then it's an edit, otherwise adding
    const title = id ? 'Edit' : 'Add';
    this.setState({ title });

    setBreadcrumbs([
      { label: 'Scheduled Tasks', href: '/scheduled-tasks' },
      { label: title, href: match.url },
    ]);

    const { user } = this.props;
    const fiId = user.financialInstitutionId || user.fiSelectedAccountId;

    if (fiId) {
      await Promise.all([fetchTasks(fiId)]);

      if (id) {
        this.buildData(+id);
      }
    }

    this.setState({ loading: false });
  }

  handleSubmit = async values => {
    const { match } = this.props;
    const { id } = match.params;

    if (id) {
      return this.updateAccountTask(id, values);
    }
    return this.addAccountTask(values);
  };

  showModal = () => {
    this.toggleModal(true);
  };

  hideModal = () => {
    this.toggleModal(false);
  };

  toggleModal(value) {
    this.setState({ confirmChangesModal: value });
  }

  async addAccountTask(formValues) {
    const { addAccountTask, user, history } = this.props;
    const { ...values } = formValues;
    const fiId = user.financialInstitutionId || user.fiSelectedAccountId;

    await addAccountTask({
      ...values,
      fi: fiId,
      taskTypeId: values.taskTypeId.value,
      taskFrequencyId: values.taskFrequencyId.value,
      taskEmail: values.taskEmail,
      taskLastStart: values.taskLastStart
        ? dayjs(values.taskLastStart).toISOString()
        : null,
    });

    const { account } = this.props;

    if (account.isError()) {
      return reduceServerErrors(account);
    }

    toast(UiToastAdapter('Task added Successfully', 'success'));
    history.push('/scheduled-tasks');
    return undefined;
  }

  async updateAccountTask(id, formValues) {
    const { updateAccountTask, user, history } = this.props;
    const { ...values } = formValues;
    const fiId = user.financialInstitutionId || user.fiSelectedAccountId;

    await updateAccountTask({
      ...values,
      fi: fiId,
      taskId: id,
      taskTypeId: values.taskTypeId.value,
      taskFrequencyId: values.taskFrequencyId.value,
      taskEmail: values.taskEmail,
      taskLastStart: values.taskLastStart
        ? dayjs(values.taskLastStart).toISOString()
        : null,
    });

    const { account } = this.props;

    if (account.isError()) {
      return reduceServerErrors(account);
    }

    toast(UiToastAdapter('Task updated Successfully', 'success'));
    history.push('/scheduled-tasks');
    return undefined;
  }

  buildData(id) {
    const { account } = this.props;
    // +id returns numeric expression of id in javascript
    const task = account.tasks.find(element => element.taskId === +id);
    const taskType =
      // eslint-disable-next-line no-nested-ternary
      task.taskTypeId === 1
        ? 'Change Notification'
        : // eslint-disable-next-line no-nested-ternary
        task.taskTypeId === 2
        ? 'SAR Notification'
        : // eslint-disable-next-line no-nested-ternary
        task.taskTypeId === 3
        ? 'Background Check Notification'
        : // eslint-disable-next-line no-nested-ternary
        task.taskTypeId === 6
        ? 'Account Processing Check Notification'
        : // eslint-disable-next-line no-nested-ternary
          task.taskTypeId;

    const taskFrequency =
      // eslint-disable-next-line no-nested-ternary
      task.taskFrequencyId === 1
        ? 'Hourly'
        : // eslint-disable-next-line no-nested-ternary
        task.taskFrequencyId === 2
        ? 'Daily'
        : // eslint-disable-next-line no-nested-ternary
        task.taskFrequencyId === 3
        ? 'Weekly'
        : // eslint-disable-next-line no-nested-ternary
        task.taskFrequencyId === 4
        ? 'Monthly'
        : // eslint-disable-next-line no-nested-ternary
        task.taskFrequencyId === 5
        ? 'Quarterly'
        : task.taskFrequencyId === 6
        ? 'Yearly'
        : task.taskFrequencyId;

    if (task) {
      const initialValues = {
        ...task,
        taskTypeId: { value: task.taskTypeId, label: taskType },
        taskFrequencyId: { value: task.taskFrequencyId, label: taskFrequency },
        taskLastStart: task.taskLastStart
          ? dayjs(task.taskLastStart)
              .utc()
              .toDate()
          : null,
      };

      this.setState({ initialValues });
    }
  }

  render() {
    const { isExpanded } = this.props;
    const { title, confirmChangesModal, loading, initialValues } = this.state;

    return (
      <>
        <MuiTitle isSize="4" hasTextColor="info" tag="h2">
          {`${title} Task`}
          <NavLink
            className="close-page button is-small is-text is-pulled-right"
            to="/scheduled-tasks"
          >
            <span className="icon has-text-danger">
              <FontAwesomeIcon icon={['fal', 'times-circle']} size="2x" />
            </span>
          </NavLink>
        </MuiTitle>
        <Form
          onSubmit={this.handleSubmit}
          initialValues={initialValues}
          subscription={{
            submitting: true,
            dirty: true,
            hasValidationErrors: true,
            dirtySinceLastSubmit: true,
          }}
          render={({
            handleSubmit,
            submitting,
            hasValidationErrors,
            dirty,
            dirtySinceLastSubmit,
            values,
            form,
            task,
          }) => {
            return (
              <Card>
                <CardContent>
                  <ScheduledTasksEditForm
                    onSubmit={handleSubmit}
                    submitting={submitting}
                    hasValidationErrors={hasValidationErrors}
                    isDirty={dirtySinceLastSubmit || dirty}
                    isExpanded={isExpanded}
                    values={values}
                    form={form}
                    confirmChangesModal={confirmChangesModal}
                    task={task}
                  />
                </CardContent>
                <InnerLoader visible={loading || submitting} />
              </Card>
            );
          }}
        />
      </>
    );
  }
}

ScheduledTasksEditPage.propTypes = {
  history: propTypes.object.isRequired,
  match: propTypes.object.isRequired,
  account: propTypes.object.isRequired,
  setBreadcrumbs: propTypes.func.isRequired,
  addAccountTask: propTypes.func.isRequired,
  updateAccountTask: propTypes.func.isRequired,
  fetchTasks: propTypes.func.isRequired,
  user: propTypes.object.isRequired,
  isExpanded: propTypes.bool.isRequired,
};

function mapStateToProps(state) {
  return {
    user: getUser(state),
    account: getAccount(state),
  };
}

const connectedScheduledTasksEditPage = connect(mapStateToProps, {
  setBreadcrumbs,
  fetchTasks,
  addAccountTask,
  updateAccountTask,
})(ScheduledTasksEditPage);

const finalConnectedComponent = connect(
  mapStateToProps,
  {
    setBreadcrumbs,
    fetchTasks,
    addAccountTask,
    updateAccountTask,
  }
)(withNavigation(connectedScheduledTasksEditPage));

export { finalConnectedComponent as ScheduledTasksEditPage };
